import { fillText } from 'components/invoiceImport/invoiceImportText';
import UseContext from 'hooks/useContext';
import { useMemo } from 'react';

/**
 * The texts of a part of the app (locales: `<namespace>.*`). `text(key,
 * values)` fills the {placeholders}; `plural(key, count)` reads `<key>One` or
 * `<key>Other`, with {count} filled. French puts 0 in the singular (« 0
 * contact joint »), English only 1. The same functions while the language
 * stays: they can sit in the dependencies of an effect or a memo.
 */
const useText = (namespace) => {
  const { language } = UseContext();
  return useMemo(() => {
    const text = (key, values = {}) =>
      fillText(language.getValue(`${namespace}.${key}`, ''), values);
    // The Language manager keeps only the current texts map, not its name:
    // French is recognised by its map.
    const isFrench =
      !!language?.current && language.current === language.languages?.get('fr');
    const isSingular = (count) => (isFrench ? count < 2 : count === 1);
    return {
      language,
      text,
      plural: (key, count, values = {}) =>
        text(`${key}${isSingular(count) ? 'One' : 'Other'}`, {
          count,
          ...values,
        }),
    };
  }, [language, namespace]);
};

export default useText;
